import OTPConfirmationModal from "@/plugins/otp/components/OTPConfirmationModal";
import OTPVerificationModal from "@/plugins/otp/components/OTPVerificationModal";

const AuthPlugin = {
  install(app, options) {
    this.params = options;
    /**
     * Plugin API
     */
    app.config.globalProperties.$auth = {
      showOTPConfirmationModal(params) {
        return app.config.globalProperties.$modal.show(OTPConfirmationModal, params);
      },
      showOTPVerificationModal(params) {
        return app.config.globalProperties.$modal.show(OTPVerificationModal, params);
      },
    };
    this.$auth = app.config.globalProperties.$auth;
  },
};

export default AuthPlugin;
